/* eslint-disable react/prop-types */
import React from "react";
import {
  Box,
  Divider,
  Flex,
  Heading,
  IconButton,
  Image,
  SimpleGrid,
  Text,
} from "@chakra-ui/react";
import { EditIcon } from "@chakra-ui/icons";

import {
  agencyContactFromDraft,
  employerContactFromDraft,
  showAgencyContactFields,
  showEmployerContactFields,
} from "../helpers/jobContactFields";
import {
  formatDateInputValue,
  formatPayLabel,
  missingPreviewFieldKeys,
  vesselFromDraft,
  workLocationLabelFromDraft,
} from "../helpers/jobCreateFlowHelpers";
import { ownerName } from "../helpers/jobOwner";

import image1 from "../assets/img/predefinedImages/predefinedImages-1.png";
import image2 from "../assets/img/predefinedImages/predefinedImages-2.png";
import image3 from "../assets/img/predefinedImages/predefinedImages-3.png";
import image4 from "../assets/img/predefinedImages/predefinedImages-4.png";
import image5 from "../assets/img/predefinedImages/predefinedImages-5.png";
import image6 from "../assets/img/predefinedImages/predefinedImages-6.png";
import image7 from "../assets/img/predefinedImages/predefinedImages-7.png";
import image8 from "../assets/img/predefinedImages/predefinedImages-8.png";
import image9 from "../assets/img/predefinedImages/predefinedImages-9.png";
import image10 from "../assets/img/predefinedImages/predefinedImages-10.png";
import image11 from "../assets/img/predefinedImages/predefinedImages-11.png";
import image12 from "../assets/img/predefinedImages/predefinedImages-12.png";
import image13 from "../assets/img/predefinedImages/predefinedImages-13.png";
import image14 from "../assets/img/predefinedImages/predefinedImages-14.png";
import image15 from "../assets/img/predefinedImages/predefinedImages-15.png";
import image16 from "../assets/img/predefinedImages/predefinedImages-16.png";
import image17 from "../assets/img/predefinedImages/predefinedImages-17.png";
import image18 from "../assets/img/predefinedImages/predefinedImages-18.png";
import image19 from "../assets/img/predefinedImages/predefinedImages-19.png";
import image20 from "../assets/img/predefinedImages/predefinedImages-20.png";
import image21 from "../assets/img/predefinedImages/predefinedImages-21.png";
import image22 from "../assets/img/predefinedImages/predefinedImages-22.png";
import image23 from "../assets/img/predefinedImages/predefinedImages-23.png";
import image24 from "../assets/img/predefinedImages/predefinedImages-24.png";
import image25 from "../assets/img/predefinedImages/predefinedImages-25.png";
import image26 from "../assets/img/predefinedImages/predefinedImages-26.png";
import image27 from "../assets/img/predefinedImages/predefinedImages-27.png";
import image28 from "../assets/img/predefinedImages/predefinedImages-28.png";
import image29 from "../assets/img/predefinedImages/predefinedImages-29.png";
import image33 from "../assets/img/predefinedImages/predefinedImages-33.png";
import image34 from "../assets/img/predefinedImages/predefinedImages-34.png";
import image35 from "../assets/img/predefinedImages/predefinedImages-35.png";
import image36 from "../assets/img/predefinedImages/predefinedImages-36.png";
import image37 from "../assets/img/predefinedImages/predefinedImages-37.png";
import image38 from "../assets/img/predefinedImages/predefinedImages-38.png";
import image39 from "../assets/img/predefinedImages/predefinedImages-39.png";
import image40 from "../assets/img/predefinedImages/predefinedImages-40.png";
import image41 from "../assets/img/predefinedImages/predefinedImages-41.png";
import image42 from "../assets/img/predefinedImages/predefinedImages-42.png";
import image43 from "../assets/img/predefinedImages/predefinedImages-43.png";
import image44 from "../assets/img/predefinedImages/predefinedImages-44.png";
import image45 from "../assets/img/predefinedImages/predefinedImages-45.png";
import image46 from "../assets/img/predefinedImages/predefinedImages-46.png";
import image47 from "../assets/img/predefinedImages/predefinedImages-47.png";
import image48 from "../assets/img/predefinedImages/predefinedImages-48.png";
import image49 from "../assets/img/predefinedImages/predefinedImages-49.png";

const COVER_IMAGES = [
  image1, image2, image3, image4, image5, image6,
  image7, image8, image9, image10, image11,
  image12, image13, image14, image15, image16, image17,
  image18, image19, image20, image21, image22, image23,
  image24, image25, image26, image27, image28, image29,
  image33, image34, image35, image36, image37, image38,
  image39, image40, image41, image42, image43, image44,
  image45, image46, image47, image48, image49,
];

const EMPLOYMENT_LABELS = {
  FullTime: "Full Time",
  PartTime: "Part Time",
  Contract: "Contract",
};

const PAY_FREQUENCIES = {
  Hourly: "Per Hour",
  Daily: "Per Day",
  Weekly: "Per Week",
  Monthly: "Per Month",
  Yearly: "Per Year",
};

const PAY_CURRENCY_OPTIONS = [
  { value: "GBP", label: "GBP (£)" },
  { value: "USD", label: "USD ($)" },
];

const PAY_FREQUENCY_OPTIONS = Object.entries(PAY_FREQUENCIES).map(([value, label]) => ({
  value,
  label,
}));

async function urlToFile(url) {
  const response = await fetch(url);
  const blob = await response.blob();
  return new File([blob], "cover.png", { type: blob.type || "image/png" });
}

function ContactPreviewSection({ title, contact, onEdit }) {
  return (
    <>
      <Divider />
      <Box p={4}>
        <SectionHeader title={title} onEdit={onEdit} />
        <Text fontWeight="semibold">{contact.name || "—"}</Text>
        {contact.email && <Text color="gray.700">{contact.email}</Text>}
        {contact.phone && <Text color="gray.700">{contact.phone}</Text>}
      </Box>
    </>
  );
}

const MISSING_FIELD_GLOW_PROPS = {
  borderWidth: "1px",
  borderColor: "orange.400",
  borderRadius: "md",
  boxShadow: "0 0 0 1px var(--chakra-colors-orange-400), 0 0 14px rgba(237, 137, 54, 0.55)",
};

const REQUIRED_BEFORE_PUBLISH_GLOW_PROPS = {
  ...MISSING_FIELD_GLOW_PROPS,
  boxShadow: "0 0 0 1px var(--chakra-colors-orange-400), 0 0 18px rgba(237, 137, 54, 0.65)",
};

function MissingFieldHighlight({ active, children, p = 2, bg = "orange.50", ...rest }) {
  if (!active) return children;
  return (
    <Box p={p} bg={bg} {...MISSING_FIELD_GLOW_PROPS} {...rest}>
      {children}
    </Box>
  );
}

function SectionHeader({ title, onEdit, highlight }) {
  return (
    <Flex align="center" justify="space-between" mb={2}>
      <Text
        fontSize="sm"
        fontWeight="bold"
        color={highlight ? "orange.500" : "gray.500"}
        textTransform="uppercase"
        letterSpacing="wide"
      >
        {title}
      </Text>
      {onEdit && (
        <IconButton
          aria-label={`Edit ${title}`}
          icon={<EditIcon />}
          size="xs"
          variant="ghost"
          color={highlight ? "orange.500" : undefined}
          onClick={onEdit}
        />
      )}
    </Flex>
  );
}

function InfoCell({ label, value, onEdit, highlight }) {
  const cell = (
    <Flex align="flex-start" justify="space-between">
      <Box>
        <Text
          fontSize="xs"
          color={highlight ? "orange.500" : "gray.500"}
          textTransform="uppercase"
        >
          {label}
        </Text>
        <Text fontWeight="medium" color={highlight ? "orange.600" : undefined}>
          {value || "—"}
        </Text>
      </Box>
      {onEdit && (
        <IconButton
          aria-label={`Edit ${label}`}
          icon={<EditIcon />}
          size="xs"
          variant="ghost"
          color={highlight ? "orange.500" : undefined}
          onClick={onEdit}
        />
      )}
    </Flex>
  );

  return (
    <MissingFieldHighlight active={highlight} mx={highlight ? -2 : undefined}>
      {cell}
    </MissingFieldHighlight>
  );
}

// A draft hydrated from an existing job carries its uploaded cover as a URL;
// a draft from the create flow only has an index into the predefined set.
// Picking a predefined image in the editor clears the URL, so the URL wins
// whenever it is present.
function coverImageSrc(draft) {
  return draft.coverImageUrl || COVER_IMAGES[draft.coverImageIndex] || COVER_IMAGES[0];
}

function PreviewCard({ draft, vessels, clientOrgs, workLocationNameById, agencyType, onEdit }) {
  const typeLabel = EMPLOYMENT_LABELS[draft.employmentType] || draft.employmentType || "—";
  const payLabel = formatPayLabel(draft);
  const vessel = vesselFromDraft(draft, vessels);
  const showEmployer = showEmployerContactFields(agencyType);
  const showAgency = showAgencyContactFields(agencyType);
  const departmentName = clientOrgs.find((c) => c.id === draft.clientOrganizationId)?.name;
  const jobLocationsLabel = workLocationLabelFromDraft(draft, workLocationNameById);
  const missingKeys = missingPreviewFieldKeys(draft);
  const isMissing = (key) => missingKeys.has(key);

  return (
    <Box
      bg="white"
      color="gray.800"
      borderRadius="lg"
      overflow="hidden"
      shadow="md"
      borderWidth="1px"
    >
      <MissingFieldHighlight
        active={isMissing("coverImage")}
        p={0}
        bg="transparent"
        borderRadius="none"
        mx={0}
      >
        <Box position="relative">
          <Image
            src={coverImageSrc(draft)}
            alt="Job cover"
            w="100%"
            h="200px"
            objectFit="cover"
          />
          <IconButton
            aria-label="Edit cover image"
            icon={<EditIcon />}
            size="sm"
            position="absolute"
            top={3}
            right={3}
            onClick={() => onEdit("coverImage")}
          />
          <Box
            position="absolute"
            bottom={0}
            left={0}
            right={0}
            bgGradient="linear(to-t, blackAlpha.700, transparent)"
            color="white"
            p={4}
          >
            <Flex align="center" justify="space-between">
              <MissingFieldHighlight
                active={isMissing("category")}
                p={2}
                bg="blackAlpha.500"
                display="inline-block"
              >
                <Heading size="md">{draft.category || "Untitled"}</Heading>
              </MissingFieldHighlight>
              <IconButton
                aria-label="Edit job title"
                icon={<EditIcon />}
                size="sm"
                colorScheme="whiteAlpha"
                onClick={() => onEdit("category")}
              />
            </Flex>
          </Box>
        </Box>
      </MissingFieldHighlight>

      <SimpleGrid columns={{ base: 2, md: 3 }} spacing={4} p={4} bg="gray.50">
        <InfoCell
          label="Department"
          value={departmentName}
          onEdit={() => onEdit("client")}
          highlight={isMissing("client")}
        />
        <InfoCell
          label="Job Locations"
          value={jobLocationsLabel}
          onEdit={() => onEdit("jobLocations")}
          highlight={isMissing("jobLocations")}
        />
        <InfoCell
          label="Location Description"
          value={draft.location}
          onEdit={() => onEdit("location")}
          highlight={isMissing("location")}
        />
        <InfoCell
          label="Employment Type"
          value={typeLabel}
          onEdit={() => onEdit("employmentType")}
          highlight={isMissing("employmentType")}
        />
        <InfoCell label="Pay" value={payLabel} onEdit={() => onEdit("pay")} />
        <InfoCell label="Duration" value={draft.duration} onEdit={() => onEdit("duration")} />
        <InfoCell label="Vessel" value={vessel.name} onEdit={() => onEdit("vessel")} />
        <InfoCell
          label="Start Date"
          value={draft.isAsap ? "ASAP" : formatDateInputValue(draft.startDate)}
          onEdit={() => onEdit("startDate")}
          highlight={isMissing("startDate")}
        />
        <InfoCell
          label="Openings"
          value={draft.numOpenings != null ? String(draft.numOpenings) : ""}
          onEdit={() => onEdit("numOpenings")}
          highlight={isMissing("numOpenings")}
        />
        <InfoCell label="Owner" value={ownerName(draft.owner)} onEdit={() => onEdit("owner")} />
      </SimpleGrid>

      <Box p={4}>
        <MissingFieldHighlight active={isMissing("requirements")}>
          <SectionHeader
            title="Requirements"
            onEdit={() => onEdit("requirements")}
            highlight={isMissing("requirements")}
          />
          <Text whiteSpace="pre-line" color={isMissing("requirements") ? "orange.600" : undefined}>
            {draft.requirementsDescription || "—"}
          </Text>
        </MissingFieldHighlight>
      </Box>

      <Divider />

      <Box p={4}>
        <MissingFieldHighlight active={isMissing("responsibilities")}>
          <SectionHeader
            title="Responsibilities"
            onEdit={() => onEdit("responsibilities")}
            highlight={isMissing("responsibilities")}
          />
          <Text whiteSpace="pre-line" color={isMissing("responsibilities") ? "orange.600" : undefined}>
            {draft.responsibilitiesDescription || "—"}
          </Text>
        </MissingFieldHighlight>
      </Box>

      {vessel.name && (
        <>
          <Divider />
          <Box p={4}>
            <SectionHeader title="Vessel Details" onEdit={() => onEdit("vessel")} />
            <Text fontWeight="semibold">{vessel.name}</Text>
            {vessel.description && (
              <Text whiteSpace="pre-wrap" color="gray.700">
                {vessel.description}
              </Text>
            )}
          </Box>
        </>
      )}

      {showEmployer && (
        <ContactPreviewSection
          title="Primary Contact"
          contact={employerContactFromDraft(draft)}
          onEdit={() => onEdit("employerContact")}
        />
      )}
      {showAgency && (
        <ContactPreviewSection
          title={showEmployer ? "Agency Contact" : "Primary Contact"}
          contact={agencyContactFromDraft(draft)}
          onEdit={() => onEdit("primaryContact")}
        />
      )}
    </Box>
  );
}

export {
  COVER_IMAGES,
  EMPLOYMENT_LABELS,
  PAY_CURRENCY_OPTIONS,
  PAY_FREQUENCIES,
  PAY_FREQUENCY_OPTIONS,
  MISSING_FIELD_GLOW_PROPS,
  REQUIRED_BEFORE_PUBLISH_GLOW_PROPS,
  ContactPreviewSection,
  InfoCell,
  MissingFieldHighlight,
  PreviewCard,
  SectionHeader,
  coverImageSrc,
  urlToFile,
};
export default PreviewCard;
